import { render, staticRenderFns } from "./autoPie.vue?vue&type=template&id=ca1f8068&"
import script from "./autoPie.vue?vue&type=script&lang=js&"
export * from "./autoPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports